import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import React from 'react';
import Links from './navbar/Links';
import './footer.scss';
export var Footer = function Footer(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("footer", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "columns"
  }, /*#__PURE__*/React.createElement("div", {
    className: "column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content has-text-centered"
  }, "Info@divritenis.lv | +371 20202020 ", /*#__PURE__*/React.createElement("br", null), "Latvijas Rite\u0146brauc\u0113ju apvien\u012Bbas ofici\u0101la m\u0101jaslapa 2020")), /*#__PURE__*/React.createElement("div", {
    className: "column is-hidden-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "columns is-vcentered is-full-width has-text-centered"
  }, /*#__PURE__*/React.createElement(Links, {
    linkClassName: "footer-item"
  })))))));
};
export default Footer;